<div class="top-wrapper">
  <div class="wrapper">
    <div class="container">
      <div class="text header">Przyjęliśmy zgłoszenie pod numerem:</div>
      <div class="text claim-number"><b>{{numerSzkody}}</b></div>
      <div class="text content">Skontaktujemy się z Tobą, jeśli będziemy potrzebować dodatkowych informacji.</div>

      <div class="info-icon">
        <img ngSrc="assets/images/icons/13.05_koperta_malpa.svg" style="width:40px;height:40px;flex-shrink:0;" alt="Mail" height="51" width="50">
        <div class="text info">Potwierdzenie i numer zgłoszenia znajdziesz w e-mailu.</div>
      </div>
      <div class="info-icon">
        <img ngSrc="assets/images/icons/17.23_monitor.svg" style="width:40px;height:40px;flex-shrink:0;" alt="Moje" height="51" width="50">
        <div class="text info">Wejdź na mojePZU i śledź status swojego zgłoszenia.</div>
      </div>

      <div *ngIf="!tenantCC" class="text info">
        Możesz teraz dołączyć dokumenty do swojej sprawy, na przykład zdjęcia uszkodzeń.
      </div>

  <!--  m  Ze względu na zachowanie i styl przycisków nawigacyjnych zgodnie z akietą specyficzne dla danego ekranu, przyciski nawigacyjne w bieżącym komponencie-->
      <div [ngClass]="tenantCC ? 'navigation-buttons-center' : 'navigation-buttons'">
        <div *ngIf="czyMoznaZglosicKolejnaSprawe()" [ngClass]="tenantCC ? 'c-button--primary' : 'c-button--secondary'" class="c-button u-margin-bottom" appThrottleClick (clickFunction)="createNextClaim()">DODAJ KOLEJNĄ SPRAWĘ</div>
        <div *ngIf="czyMoznaPrzejscNaMojePzu()" class="c-button--secondary c-button u-margin-bottom" appThrottleClick (clickFunction)="goToMojePzu()">PRZEJDŹ NA mojePZU</div>
        <div *ngIf="tenantCC && kwotaUkryta" class="c-button c-button--primary u-margin-bottom" appThrottleClick (clickFunction)="zakoncz()">ZAKOŃCZ</div>
        <div *ngIf="!tenantCC" class="c-button c-button--primary u-margin-bottom pl-5 pr-5" appThrottleClick (clickFunction)="kliknietoDodajDokument()">DODAJ DOKUMENTY</div>
      </div>
    </div>
  </div>

  <footer *ngIf="!tenantCC" class="footer pt-2 pb-2" style="justify-content: center; margin-bottom: 0; background: #FFF">
    <div class="footer-content">
      <div class="footer-elements">
        <span class='u-font-color--1 footer-text'>Twoje zdanie jest ważne, pomóż nam lepiej zrozumieć Twoje potrzeby.</span>
        <div class="survey-button">
          <a class="o-link" (click)="logLinkActivity(LinkType.NPS_QUESTIONNAIRE)" href='{{linkAnkieta}}' target="_blank" style="text-decoration:none;">
            <div class="survey-text">WYPEŁNIJ ANKIETĘ</div>
          </a>
        </div>
      </div>
    </div>
  </footer>
</div>
